module.exports = __webpack_public_path__ + "img/20-mob.0bdf1350.svg";